/* eslint-disable */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import home from '../views/home/home.vue'
import login from '../views/login/login.vue'
Vue.use(VueRouter)



const routes: Array<RouteConfig> = [
  {
    path: '/administrators',
    name: 'administrators',
    component: home,
    redirect: 'administrators/administrators/list',
    children: [
      {
        path: 'administrators/home',
        name: 'administratorshome',
        component: () => import('../views/administrators/home.vue')
      },
      {
        path: 'administrators/list',
        name: 'administratorslist',
        component: () => import('../views/administrators/list.vue')
      }, {
        path: 'administrators/log',
        name: 'administratorslog',
        component: () => import('../views/administrators/log.vue')
      },
      {
        path: 'administrators/add',
        name: 'administratorsadd',
        component: () => import('../views/administrators/add.vue')
      },
      {
        path: 'administrators/details',
        name: 'administratorsdetails',
        component: () => import('../views/administrators/details.vue')
      },
    ]
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    redirect: '/home/enterprise/personnel/employeeList',
    children: [
      {
        path: 'administrators/home',
        name: 'administratorshome',
        component: () => import('../views/administrators/home.vue')
      },
      {
        path: 'administrators/list',
        name: 'administratorslist',
        component: () => import('../views/administrators/list.vue')
      }, {
        path: 'administrators/log',
        name: 'administratorslog',
        component: () => import('../views/administrators/log.vue')
      },
      {
        path: 'administrators/add',
        name: 'administratorsadd',
        component: () => import('../views/administrators/add.vue')
      },
      {
        path: 'administrators/details',
        name: 'administratorsdetails',
        component: () => import('../views/administrators/details.vue')
      },
      {
        path: 'enterprise/enterprise',
        name: 'enterprise',
        component: () => import('../views/enterprise/enterprise.vue')
      },
      {
        path: 'enterprise/personnel/employeeList',
        name: 'employeeList',
        component: () => import('../views/enterprise/personnel/employeeList.vue')
      },
      {
        path: 'enterprise/personnel/add',
        name: 'personneladd',
        component: () => import('../views/enterprise/personnel/add.vue')
      },
      {
        path: 'enterprise/personnel/details',
        name: 'personneldetails',
        component: () => import('../views/enterprise/personnel/details.vue')
      },
      {
        path: 'enterprise/personnel/employeeWorkload',
        name: 'employeeWorkload',
        component: () => import('../views/enterprise/personnel/employeeWorkload/employeeWorkload.vue')
      },
      {
        path: 'enterprise/personnel/employeeWorkloadadd',
        name: 'employeeWorkloadadd',
        component: () => import('../views/enterprise/personnel/employeeWorkload/employeeWorkloadadd.vue')
      },
      {
        path: 'enterprise/personnel/employeeWorkloaddetails',
        name: 'employeeWorkloaddetails',
        component: () => import('../views/enterprise/personnel/employeeWorkload/employeeWorkloaddetails.vue')
      },
      {
        path: 'enterprise/employeeWorkload/employeeWorkloadAllList',
        name: 'employeeWorkloadAllList',
        component: () => import('../views/enterprise/employeeWorkload/employeeWorkloadAllList.vue')
      },
      {
        path: 'enterprise/department/list',
        name: 'departmentList',
        component: () => import('../views/enterprise/department/list.vue')
      },
      {
        path: 'enterprise/department/details',
        name: 'departmentDetails',
        component: () => import('../views/enterprise/department/details.vue')
      },
      {
        path: 'enterprise/department/add',
        name: 'departmentAdd',
        component: () => import('../views/enterprise/department/add.vue')
      },
      {
        path: 'enterprise/pay/employeeSalary',
        name: '员工月工资',
        component: () => import('../views/enterprise/pay/employeeSalary.vue')
      },
      {
        path: 'enterprise/batch/batchList',
        name: 'batchList',
        component: () => import('../views/enterprise/batch/batchList.vue')
      },
      {
        path: 'enterprise/batch/batchListProgress',
        name: 'batchListProgress',
        component: () => import('../views/enterprise/batch/batchListProgress.vue')
      },
      {
        path: 'enterprise/batch/batchdetails',
        name: 'batchdetails',
        component: () => import('../views/enterprise/batch/batchdetails.vue')
      },
      {
        path: 'enterprise/batch/batchStatistics',
        name: 'batchStatistics',
        component: () => import('../views/enterprise/batch/batchStatistics.vue')
      },
      {
        path: 'enterprise/batch/batchHcharts',
        name: 'batchHcharts',
        component: () => import('../views/enterprise/batch/batchHcharts.vue')
      },
      {
        path: 'enterprise/batch/ProcessDetails',
        name: 'processdetails',
        component: () => import('../views/enterprise/batch/processdetails.vue')
      },
      {
        path: 'enterprise/pay/employeeSalary',
        name: 'employeeSalary',
        component: () => import('../views/enterprise/pay/employeeSalary.vue')
      },
      {
        path: 'enterprise/pay/punchStatistics',
        name: 'punchStatistics',
        component: () => import('../views/enterprise/pay/punchStatistics.vue')
      },
      {
        path: 'enterprise/pay/punchStatisticsddetails',
        name: 'punchStatisticsddetails',
        component: () => import('../views/enterprise/pay/punchStatisticsddetails.vue')
      },
      {
        path: 'enterprise/log/batchOperation',
        name: '批次操作记录',
        component: () => import('../views/enterprise/log/batchOperation.vue')
      },
      {
        path: 'enterprise/log/workloadOperation',
        name: '工作量操作记录',
        component: () => import('../views/enterprise/log/workloadOperation.vue')
      },
      {
        path: 'enterprise/log/employeeInformation',
        name: '员工信息操记录',
        component: () => import('../views/enterprise/log/employeeInformation.vue')
      },
      {
        path: 'enterprise/log/businessOperations',
        name: '企业信息操记录',
        component: () => import('../views/enterprise/log/businessOperations.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/login',
    name: 'login',
    component: login
  }
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
